module.exports = __webpack_public_path__ + "img/help_empty@3x.f2dc5eb7.png";